<template>
  <div>
    <transition appear @before-enter="$animations.beforeEnterLogoArea" @enter="$animations.enterLogoArea">
      <Logo></Logo>
    </transition>
    <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en` && $root.formData.childrenAccountOpeningPurpose == `For another person's child (Gift Account)`" class="column" style="text-align: center">
          <img src="../assets/images/icons/updatedIcons/donorFlow/accountSelection.png" alt="contact-img" width="85%" />
        </div>
        <div v-if="$root.selectedLanguage === `en` && $root.formData.childrenAccountOpeningPurpose != `For another person's child (Gift Account)`" class="column" style="text-align: center">
          <img src="../assets/images/icons/updatedIcons/normalFlow/accountSection.png" alt="contact-img" width="85%" />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37572.png" alt="contact-img" width="70%" />
        </div>
      </div>
    </transition>

    <div class="card px-3 py-5  " style="width: 80%; margin: 0 auto 80px auto; ">

      <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
        <div class="columns is-centered">
          <div class="column  ps-5" style="text-align: center">
            <img src="../assets/images/icons/Blue/account_logo.png" alt="contact-info-img" width="70" height="70" />
            <p :class="`text-center mx-3 mb-2 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
              }`"
               style="font-family:OpenSans-Bold;">
              {{ $root.selectedLanguageData.accountSelection }}
            </p>
            <p :class="`${$root.selectedLanguage === `ta`
              ? `ta-sub-line`
              : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
              }`"
               style="font-family:OpenSans-Bold;">
              {{ $root.selectedLanguageData.unlock_your_ideal_account_experience }}
            </p>
            <p>
              {{ $root.selectedLanguageData.fill_the_below_form }}
            </p>
          </div>
        </div>
      </transition>
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="" autocomplete="off">
          <div class="columns is-centered">

            <div class="column is-three-quarters pt-5 ps-5">
              <!-- residence select start -->
<!--              <div class="field column ">-->

<!--                <label :class="`${$root.selectedLanguage === `ta`-->
<!--                  ? `ta-label`-->
<!--                  : $root.selectedLanguage === `si`-->
<!--                    ? `si-label`-->
<!--                    : ``-->
<!--                  }`">{{ $root.selectedLanguageData.residency-->
<!--  }}<span class="has-text-danger">*</span></label>-->
<!--                <div class="columns">-->
<!--                  <div class="column is-one-two">-->
<!--                    <b-field>-->
<!--                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                        <b-radio name="residence" style="font-family: fira400" native-value="Resident in Sri Lanka"-->
<!--                          @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"-->
<!--                          @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"-->
<!--                          @click.native="countrySelect(`Sri Lanka`)">-->
<!--                          {{-->
<!--                            $root.selectedLanguageData.residentInSriLanka-->
<!--                          }} </b-radio><span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </b-field>-->
<!--                  </div>-->
<!--                  <div class="column is-8">-->
<!--                    <b-field>-->
<!--                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                        <b-radio name="residence" style="font-family: fira400" native-value="Non Resident"-->
<!--                          @focus="$inputFocused('residentship')" @input="$inputChanged('residentship')"-->
<!--                          @blur="$inputBlured('residentship')" v-model="$root.formData.residentship"-->
<!--                          @click.native="countrySelect(``)">-->
<!--                          {{ $root.selectedLanguageData.nonResident }} </b-radio><span class="has-text-danger">{{-->
<!--                            errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </b-field>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
              <!-- residence select end-->

              <!-- select country start here -->
<!--              <div v-if="$root.formData.residentship === `Non Resident`">-->
<!--                <div>-->
<!--                  <label :class="`${$root.selectedLanguage === `ta`-->
<!--                    ? `ta-label`-->
<!--                    : $root.selectedLanguage === `si`-->
<!--                      ? `si-label`-->
<!--                      : ``-->
<!--                    }`">{{-->
<!--    $root.selectedLanguageData-->
<!--      .please_select_the_country_of_residence-->
<!--  }}<span class="has-text-danger">*</span></label>-->

<!--                  <div>-->
<!--                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                      <div style="width: 100%">-->
<!--                        <b-select @focus="$inputFocused('resident_countries')"-->
<!--                          @input="$inputChanged('resident_countries')" @blur="$inputBlured('resident_countries')"-->
<!--                          v-model="$root.formData.resident_countries" expanded>-->
<!--                          <option v-for="country in countriesArray" :key="country.value" :value="country.value">-->
<!--                            {{ country.countryName }}-->
<!--                          </option>-->
<!--                        </b-select>-->
<!--                      </div>-->
<!--                      <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                    </ValidationProvider>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div v-if="-->
<!--                  $root.formData.residentship ===-->
<!--                  `Non Resident` ">-->
<!--                <div>-->
<!--                  <label :class="`${$root.selectedLanguage === `ta`-->
<!--                        ? `ta-label`-->
<!--                        : $root.selectedLanguage === `si`-->
<!--                          ? `si-label`-->
<!--                          : ``-->
<!--                      }`">-->
<!--                    {{-->
<!--                      $root.selectedLanguageData-->
<!--                          .specifyTheCountry-->
<!--                    }}<span class="has-text-danger">*</span></label>-->

<!--                  <div>-->
<!--                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                      <div style="width: 100%">-->
<!--                        <b-select @focus="$inputFocused('resident_country')"-->
<!--                                  @input="$inputChanged('resident_country')"-->
<!--                                  @blur="$inputBlured('resident_country')" v-model="$root.formData.resident_country"-->
<!--                                  expanded>-->
<!--                          <option v-for="country in countriesArray" :key="country.value" :value="country.value">-->
<!--                            {{ country.countryName }}-->
<!--                          </option>-->
<!--                        </b-select>-->
<!--                      </div>-->
<!--                      <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                    </ValidationProvider>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
              <!-- select country end here -->

              <!-- Citizenship select start here -->
<!--              <div class="mb-5 mt-4"> &lt;!&ndash; (v-if="$root.kycFieldVisibility.citizenship") need to add &ndash;&gt;-->
<!--                <label :class="`${$root.selectedLanguage === `ta`-->
<!--                  ? `ta-label`-->
<!--                  : $root.selectedLanguage === `si`-->
<!--                    ? `si-label`-->
<!--                    : ``-->
<!--                  }`">-->
<!--                  {{ $root.selectedLanguageData.nationalityCitizenship-->
<!--                  }}<span class="has-text-danger">*</span></label>-->
<!--                <div style="width: 100%">-->
<!--                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">-->
<!--                    <b-select style="width: 100%" expanded v-model="$root.formData.citizenship"-->
<!--                      @focus="$inputFocused('citizenship')" @input="-->
<!--                        () => {-->
<!--                          $inputChanged('citizenship');-->
<!--                          dualCitizenCounties();-->
<!--                        }-->
<!--                      " @blur="$inputBlured('citizenship')">-->
<!--                      <option value="Sri Lankan">-->
<!--                        {{ $root.selectedLanguageData.srilanka }}-->
<!--                      </option>-->
<!--                      <option value="Sri Lankan with Dual Citizenship">-->
<!--                        {{-->
<!--                          $root.selectedLanguageData-->
<!--                            .sriLankanWithDualCitizenship-->
<!--                        }}-->
<!--                      </option>-->
                      <!-- <option value="Foreign National">
                        {{ $root.selectedLanguageData.foreignNational }}
                      </option>
                      <option value="Foreign National with Dual Citizenship">
                        {{
                          $root.selectedLanguageData
                            .foreignNationalWithDualCitizenship
                        }}
                      </option> -->
<!--                    </b-select>-->
<!--                    <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                  </ValidationProvider>-->
<!--                </div>-->
<!--              </div>-->

              <!-- Citizenship select here here -->


              <!-- contact number start here -->
              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.mobileNumber }}<span class="has-text-danger">*</span></label>

                <div class="columns is-7 is-variable">
                  <div class="column is-4">
                    <div>
                      <section>
                        <b-field style="width: 50%">
                          <p class="control has-icons-right">
<!--                          <p class="control has-icons-right">-->
<!--                            <b-autocomplete v-model="userCode" maxlength="10" icon-pack="fi" :icon="iconString"-->
<!--                              open-on-focus :data="filteredDataArr" @input="-->
<!--                                () => {-->
<!--                                  ++count;-->
<!--                                  if (count === 2) {-->
<!--                                    $root.formData.countryCode = ``;-->
<!--                                    isCountryCodeTouched = true;-->
<!--                                  }-->
<!--                                }-->
<!--                              " @select="-->
<!--  (option) => {-->
<!--    if (option) {-->
<!--      $root.formData.countryCode = `+${option.split(`+`)[1]}`;-->
<!--      $root.formData.mobileNumberCountrySelectionTemp = option-->
<!--    } else {-->
<!--      $root.formData.countryCode = ``-->
<!--    }-->
<!--    if ($root.formData.countryCode) {-->
<!--      changeSelection();-->
<!--      calPhoneNumber();-->
<!--    }-->
<!--  }-->
<!--">-->
<!--                            </b-autocomplete>-->
<!--                            <span class="icon is-small is-right mr-2">-->
<!--                              <img src="../assets/images/icons/Blue/Stroke.png" alt="Stroke-img" width="13" height="13" />-->
<!--                            </span>-->
<!--                            <span class="has-text-danger" v-if="-->
<!--                              isCountryCodeTouched &&-->
<!--                              !$root.formData.countryCode-->
<!--                            ">You have to select a valid country code</span>-->
<!--                          </p>-->
<!--                          <b-select @input="countryCodeLogoFilter" v-model = "countryCode" placeholder="Country Code" icon-pack="fi" :icon="countryIconString">-->

<!--                            <option v-for="country in countryCodeList"-->
<!--                                    :value="country.phone"-->
<!--                                    :key="country.phone">{{country.phone}}</option>-->

<!--                          </b-select>-->
                          <ValidationProvider name="Country Code" :rules="countryCodeValidation()"
                                              v-slot="{ errors }">

                            <b-autocomplete
                                   @input="countryCodeLogoFilter" @keyup.native="countryCodeValidator" v-model="userCountryCode" placeholder="Country Code" icon-pack="fi" :icon="$root.formData.countryIconString"
                                :data="filteredDataArray"
                                   autocomplete="countryCode"
                                ref="autocomplete"
                                :select-on-click-outside="true"
                                dropdown-position ="top"
                                :open-on-focus ="true"
                                @select="option => selected = option">
                              <template #empty>No results found</template>

                            </b-autocomplete>
                            <span class="icon is-small is-right ml-6">
                        <img
                            src="@/assets/images/icons/Blue/Stroke.png"
                            alt="Stroke-3-img"
                            width="15"
                        />
                      </span>
                              <span class="has-text-danger">{{ errors[0] }}</span>
                              <br v-if="!isValidCountryCode">
                              <span class="has-text-danger" v-if="!isValidCountryCode">Invalid country code</span>

                          </ValidationProvider>
                          </p>
                        </b-field>

                      </section>

                    </div>
                  </div>
                  <div class="column is-6 is-offset-2">
                    <b-field>
                      <p class="control has-icons-right">
                        <ValidationProvider name="Phone Number" :rules="{ required: true, numeric: true }"
                          v-slot="{ errors }">
<!--                          v-model="$root.formData.mobileNumberWithoutCountryCode"-->
                          <b-input autocomplete="new-contact"   v-model="userMobileNumber"
                            @focus="$inputFocused('userMobileNumber')"
                                   @input="() => {
                                $inputChanged('userMobileNumber');
                                calPhoneNumber();
                              }
                            " @blur="$inputBlured('userMobileNumber')"
                          />
                          <span class="icon is-small is-right mr-2">
                            <img src="../assets/images/icons/Blue/Call.png" alt="contact-name-img" width="25"
                              height="25" />
                          </span>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                          <span class="has-text-danger" v-if="isMobileNumberStartsWithZero">LK phone numbers not allowed
                            to start with 0. </span>
                          <span class="has-text-danger" v-if="isLandNumber">Mobile Numbers Only</span>
                        </ValidationProvider>
                      </p>
                    </b-field>
                  </div>
                </div>
              </div>
              <!-- contact number end here -->

              <!-- email start here -->
              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.emailAddress
  }}<span class="has-text-danger">*</span></label>
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider :rules="{
                      email: true,
                      required: true,
                      lessOrEqualLength: 256,
                    }" name="Email" v-slot="{ errors }">
                      <b-input @focus="$inputFocused('email')" @input="$inputChanged('email')"
                        @blur="$inputBlured('email')" v-model="userMail" />
                      <span class="icon is-small is-right mr-2">
                        <img src="../assets/images/icons/Blue/Group 156.png" alt="contact-name-img" width="25"
                          height="25" />
                      </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>
              <!-- email end here -->


<!--              nic section-->
              <div class="field mt-4" v-if="$root.isPreviouslyDonorFilled === 0">
                <!--                  v-if="$root.kycFieldVisibility.politically_exposed_relative"-->
                <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{
                    $root.selectedLanguageData
                        .do_you_have_nic
                  }}<span class="has-text-danger">*</span></label>
                <ValidationProvider name="publicPosition" :rules="{ required: true }" v-slot="{ errors }">
                  <div class="columns">
                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="HaveNic" style="font-family: OpenSans-Regular" native-value="Yes"
                                 @focus="$inputFocused('haveNic')"
                                 @input="$inputChanged('haveNic');"
                                 @blur="$inputBlured('haveNic')"
                                 v-model="$root.formData.haveNic">
                          {{ $root.selectedLanguageData.yes }}
                        </b-radio></b-field>
                    </div>

                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="HaveNic" style="font-family: OpenSans-Regular" native-value="No"
                                 @focus="$inputFocused('haveNic');"
                                 @input="()=>{$inputChanged('haveNic'); $root.formData.customer_nic = ''}"
                                 @blur="$inputBlured('haveNic')"
                                 v-model="$root.formData.haveNic"
                                 @click.native="()=>{$root.formData.customer_nic=''; getProductListLate()}"
                     >
                          {{ $root.selectedLanguageData.no }}
                        </b-radio></b-field>
                    </div>
                  </div>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div v-if="
                  $root.formData.haveNic === `Yes` && $root.isPreviouslyDonorFilled === 0" class="mt-3">
                <!--                  &&-->
                <!--                  $root.kycFieldVisibility.politically_exposed_relative-->
                <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                  {{ $root.selectedLanguageData.nic_number}}
                  <span class="has-text-danger">*</span>
                </label>
                <b-field>
                  <p class="control has-icons-right">
                        <ValidationProvider name="NIC Number" :rules="{ required: true,multiRegex: [/^([0-9]{9}[Xx||Vv])$/, /^[0-9]{12}$/],}" v-slot="{ errors }">
                      <b-input type="text" @focus="$inputFocused('customer_nic')" @input="splitNic(); nicGenderCheck(); calculateDateOfBirth(); nicDuplicator()"
                               @blur="getProductList()" v-model="$root.formData.customer_nic"/>
                      <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />

                            </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                      <br>
                      <span v-if="!isNicValid" class="has-text-danger">Not a valid NIC </span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>
<!--              nic section-->
              <hr>

              <!-- curruncy type and preferd branch start here -->

              <div class="mt-4 columns">
                <div class="column is-one-two">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.currencyType
  }}<span class="has-text-danger">*</span>
                  </label>

                  <b-input disabled v-model="$root.formData.currency_type"></b-input>


                </div>
                <div class="column is-one-two">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.preferredBranch
  }}<span class="has-text-danger">*</span>
                  </label>

                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <!-- <b-select
                          @focus="$inputFocused('branch')"
                          @input="$inputChanged('branch')"
                          @blur="$inputBlured('branch')"
                          v-model="$root.formData.branch"
                      >
                        <option v-for="selectBranch in $root.dataLists.branchListArray" :key="selectBranch.id" :value="selectBranch.branch_name">
                          {{ selectBranch.branch_name }}
                        </option>
                      </b-select> -->
                          <b-autocomplete
                
                              v-model="$root.formData.branch"
                              :data="filteredBranchArry"
                              icon-right="magnify"
                              clearable
                              :keep-first="true"
                              field="branch_name"
                              :open-on-focus="true"
                              @select="(option)=>{checkBranchInput(option)}"
                              >
                <!-- <template #empty>No results found</template> -->
                                <template #empty>No results found</template>

            </b-autocomplete>

                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>

                </div>
              </div>

              <!-- curruncy type and preferd branch end here -->

                <div class="field mt-4" >
                <!--                  v-if="$root.kycFieldVisibility.politically_exposed_relative"-->
                <label :class="`${$root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                        ? `si-label`
                        : ``
                    }`">{{
                    $root.selectedLanguageData
                        .youAreGoningToOpen
                  }}<span class="has-text-danger">*</span></label>
                <ValidationProvider name="publicPosition" :rules="{ required: true }" v-slot="{ errors }">
                  <div class="columns">
                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="Opened account" style="font-family: OpenSans-Regular" native-value="Individual Account"
                                 @focus="$inputFocused('opendAccountType')"
                                 @input="$inputChanged('opendAccountType');"
                                 @blur="$inputBlured('opendAccountType')"
                                 v-model="$root.formData.opendAccountType">
                          {{ $root.selectedLanguageData.individualAccount }}
                        </b-radio></b-field>
                    </div>

                    <div class="column is-one-two">
                      <b-field>
                        <b-radio name="Opened account" style="font-family: OpenSans-Regular" native-value="Joint Account"
                                 @focus="$inputFocused('opendAccountType');"
                                 @input="()=>{$inputChanged('opendAccountType'); }"
                                 @blur="$inputBlured('opendAccountType')"
                                 v-model="$root.formData.opendAccountType"
                                 disabled
                     >
                          {{ $root.selectedLanguageData.jointAccount }}
                        </b-radio></b-field>
                    </div>
                  </div>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Account type and account start here -->
              <div class="mt-4 columns">
                <div class="column is-half">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.accountType
                    }}<span class="has-text-danger">*</span>
                  </label>

                  <div>
                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <b-select style="width: 100%" expanded v-model="$root.formData.account_type" :disabled="$root.formData.haveNic === '' || $root.isPreviouslyDonorFilled === 1"
                        @focus="$inputFocused('account_type')" @input="
                          () => {
                            $inputChanged('account_type');
                            fixedAccountSelector();
                          }
                        " @blur="$inputBlured('account_type')"
                      >
                        <option value="Savings Account">
                          {{ $root.selectedLanguageData.savingsAccounts }}
                        </option>
                        <option value="Fixed Account">
                          {{
                            $root.selectedLanguageData
                              .fixedAccounts
                          }}
                        </option>

                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>


                <div v-if="$root.formData.account_type === `Savings Account`" class="column is-half">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.account
                    }} <span class="has-text-danger">*</span>
                  </label>
                  <div>
                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <b-select style="width: 100%" expanded v-model="$root.formData.account"
                        @focus="$inputFocused('account')" @input="
                          () => {
                            $inputChanged('account');
                            dualCitizenCounties();
                            $root.formData.account_name = ''
                            if($root.formData.account !==`Minor Savings`){
                              $root.formData.childrenAccountOpeningPurpose = ''
                            }
                          }
                        " @blur="$inputBlured('account')"
                      :disabled="$root.isPreviouslyDonorFilled === 1">
                        <option value="Minor Savings">
                          {{ $root.selectedLanguageData.minorSaving }}
                        </option>
                        <option value="Normal Savings">
                          {{ $root.selectedLanguageData.normalSavings }}
                        </option>
                        <option value="Investment Savings">
                          {{ $root.selectedLanguageData.invesmentSavings }}
                        </option>
                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>

              <!-- Account type and account end here -->

              <!-- Account logos section start  * if account type is fixed -->
              <div class="mt-4  is-full" style="margin: 0;">

<!--                <div class="tile is-ancestor" v-if="$root.formData.account_type === `Savings Account`" >-->
<!--                  <div  v-for="(account, index) in accountFilter($root.formData.account)"-->

<!--                    :key="account.id">-->
<!--                    <div class="tile is-parent">-->
<!--                    <b-field>-->

<!--                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }" >-->
<!--                    <div class="tile is-child box my-2" :id="account.name" @click="accountSelector(account.name, account.imgurl)" >-->
<!--                      <figure class="image is-128x128">-->
<!--                        <img :src="account.imgurl">-->
<!--                      </figure>-->
<!--                    </div>-->


<!--                        <b-radio name="accountRadio" style="font-family: fira400" :native-value="account.name"-->
<!--                                v-model="$root.formData.account_name"-->
<!--                                 @click.native="()=>{accountSelector(account.name, account.imgurl)}">-->
<!--                          {{ account.name}} </b-radio><span class="has-text-danger">{{-->
<!--                          errors[0] }}</span>-->
<!--                      </ValidationProvider>-->

<!--                    </b-field>-->
<!--                    </div>-->
<!--                    <br v-if="index===3">-->
<!--                  </div>-->

<!--                </div>-->
                <div class="tile is-ancestor" v-if="$root.formData.account_type === `Savings Account` && $root.isPreviouslyDonorFilled === 0">
                  <div class="tile is-parent">
                    <div class="columns is-multiline">
                    <article  class="column is-4" v-for="(account) in accountFilter($root.formData.account)"  :key="account.id">
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }" >
                        <div class="my-2 box">
                          {{$baseUrl}}
                          <figure :id="account.name" @click="accountSelector(account.name, account.imgurl)" >
                            <b-image
                                responsive
                                :src="productImageSetter(account.imgurl)"
                            ></b-image>
                          </figure>
                        </div>
                        <b-radio  name="accountRadio" style="font-family: OpenSans-Regular" :native-value="account.name"
                                 v-model="$root.formData.account_name"
                                 @click.native="()=>{accountSelector(account.name, account.imgurl)}">
                          {{ account.name}} </b-radio>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>

                    </article>
                    </div>
                  </div>
                </div>

                <div  class="tile is-ancestor" v-else-if="$root.formData.account_type === `Fixed Account`">
                  <div class="tile is-parent">
                    <div class="columns is-multiline">
                      <article  @click="fixedAccountTimeDurationSelector()" class="column is-4" v-for="(account) in accountFilter(`Fixed Account`)"  :key="account.id">
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }" >
                          <div class="my-2 box" style="box-shadow: 0px 4px 62px rgba(0, 0, 0, 0.1);">
                            <figure :id="account.name" @click="accountSelector(account.name, account.imgurl)" >
                              <b-image
                                  responsive
                                  :src="productImageSetter(account.imgurl)"
                              ></b-image>
                            </figure>
                          </div>
                          <b-radio name="accountRadio" style="font-family: OpenSans-Regular" :native-value="account.name"
                                   v-model="$root.formData.account_name"
                                   @click.native="()=>{accountSelector(account.name, account.imgurl);}" 
                                   >
                            {{ account.name}} </b-radio>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>

                      </article>
                    </div>
                  </div>
                </div>

                <div class="tile is-ancestor" v-else-if="$root.formData.account_type === `Savings Account` && $root.isPreviouslyDonorFilled === 1">
                  <div class="tile is-parent">
                    <div class="columns is-multiline">
                    <article  class="column is-4" >
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }" >
                        <div class="my-2 box">
                          {{$baseUrl}}
                          <figure>
                            <b-image
                                responsive
                                :src="$root.formData.accountImage"
                            ></b-image>
                          </figure>
                        </div>
                        <b-radio  name="accountRadio" style="font-family: OpenSans-Regular" :native-value="$root.formData.account_name"
                                 v-model="$root.formData.account_name"
                                 disabled>
                          {{ $root.formData.account_name}} </b-radio>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>

                    </article>
                    </div>
                  </div>
                </div>








                <!--                <div class="tile is-ancestor" v-else-if="$root.formData.account_type === `Fixed Accounts`">-->
<!--                  <div class="tile is-4  is-parent" v-for="account in accountFilter(`Fixed Accounts`)" :key="account.id">-->

<!--                    <b-field>-->
<!--                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }" >-->
<!--                        <div class="tile is-child box" :id="account.name" @click="accountSelector(account.name, account.imgurl)" >-->
<!--                          <figure class="image is-128x128">-->
<!--                            <img :src="account.imgurl">-->
<!--                          </figure>-->
<!--                        </div>&lt;!&ndash;                      child closing&ndash;&gt;-->

<!--                        <b-radio name="accountRadio" style="font-family: fira400" :native-value="account.name"-->
<!--                                 @focus="$inputFocused('account_name')" @input="$inputChanged('account_name')"-->
<!--                                 @blur="$inputBlured('account_name')" v-model="$root.formData.account_name"-->
<!--                                 @click.native="()=>{accountSelector(account.name, account.imgurl)}">-->
<!--                          {{ account.name}}-->
<!--                        </b-radio>-->
<!--                        <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                      </ValidationProvider>-->
<!--                    </b-field>-->
<!--                  </div>-->
<!--                </div>-->
              </div>
<!--              <div class="tile is-ancestor"  >-->
                <div class="tile is-parent is-12" v-if="($root.formData.account_type === `Fixed Account` || $root.formData.account === `Minor Savings`|| $root.formData.account === 'Investment Savings') && $root.formData.haveNic === 'No'">
<!--                  <div class="columns">-->
                    <article  class="column has-text-centered">
                      <div class="my-2 box">
                        <span class="has-text-danger" v-if="$root.formData.account_type === `Fixed Account`">You can't open up fixed deposit accounts without having a NIC</span>
                        <span class="has-text-danger" v-else-if="$root.formData.account === `Minor Savings`">You can't open up Minor Savings without having a NIC</span>
                        <span class="has-text-danger" v-else-if="$root.formData.account === `Investment Savings`">You can't open up Investment Savingss without having a NIC</span>
                      </div>
                    </article>
<!--                  </div>-->
                </div>
<!--              </div>-->
              <!-- Account logos section end-->

<!--              children account opening purpose-->
              <div class="mt-4 columns" v-if="$root.formData.account === `Minor Savings`">
                <div class="column is-three-quarters">
                  <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.forWhomCreateAccount
                    }}<span class="has-text-danger">*</span>
                  </label>
                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <b-select style="width: 100%" expanded v-model="$root.formData.childrenAccountOpeningPurpose"
                                @focus="$inputFocused('childrenAccountOpeningPurpose')" @input="
                          () => {
                                $inputChanged('childrenAccountOpeningPurpose');
                                  isModalActive = true
                                  donorValueResetter();
                                  clearGernder();

                                }
                        " @blur="$inputBlured('childrenAccountOpeningPurpose')"
                                :disabled="$root.isPreviouslyDonorFilled === 1">
                        <option value="For my own child"
                               >
                          {{ $root.selectedLanguageData.forMyOwnChild }}
                        </option>
                        <option value="For another person's child (Gift Account)"
                       >
                          {{$root.selectedLanguageData.forAnotherPersonChild}}
                        </option>
                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                </div>
              </div>

              <div v-if="$root.formData.childrenAccountOpeningPurpose === `For another person's child (Gift Account)`">
<!--              Donors Name-->
              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.donor_name
                  }}<span class="has-text-danger">*</span></label>
                <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider :rules="{required: true, alphaSpaces: true, notStartsWith: ' ', notEndsWith: ' '}" name="Donor name" v-slot="{ errors }">
                      <b-input type="text" @focus="$inputFocused('donorsName')" @input="$inputChanged('donorsName')"
                               @blur="$inputBlured('donorsName')" v-model="$root.formData.donorsName" />
                      <span class="icon is-small is-right mr-2">
                        <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                             height="25" />
                      </span>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </p>
                </b-field>
              </div>

<!--              donors name end here-->

     <!-- residence select start -->
                <div class="field mt-4  ">

                  <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">{{ $root.selectedLanguageData.residency
                    }}<span class="has-text-danger">*</span></label>
                  <div class="columns">
                    <div class="column is-one-quarter">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="donor residence" style="font-family: OpenSans-Regular" native-value="Resident in Sri Lanka"
                                   @focus="$inputFocused('donorResidentship')" @input="$inputChanged('donorResidentship')"
                                   @blur="$inputBlured('donorResidentship')" v-model="$root.formData.donorResidentship"
                                   @click.native="countrySelect(`Sri Lanka`)"
                          >
                            {{
                              $root.selectedLanguageData.residentInSriLanka
                            }} </b-radio><span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <div class="column is-one-two">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="donor residence" style="font-family: OpenSans-Regular" native-value="Non Resident"
                                   @focus="$inputFocused('donorResidentship')" @input="$inputChanged('donorResidentship')"
                                   @blur="$inputBlured('donorResidentship')" v-model="$root.formData.donorResidentship"
                                   @click.native="countrySelect(`Non Resident`)">
                            {{ $root.selectedLanguageData.nonResident }} </b-radio><span class="has-text-danger">{{
                            errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                  </div>
                </div>
                <!-- residence select end-->

                     <div v-if="
                  $root.formData.donorResidentship ===
                  `Non Resident` ">
                  <div>
                    <label :class="`${$root.selectedLanguage === `ta`
                        ? `ta-label`
                        : $root.selectedLanguage === `si`
                          ? `si-label`
                          : ``
                      }`">
                      {{
                        $root.selectedLanguageData
                            .specifyTheCountry
                      }}<span class="has-text-danger">*</span></label>

                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('donorResidentCountry')"
                                    @input="$inputChanged('donorResidentCountry')"
                                    @blur="$inputBlured('donorResidentCountry')" v-model="$root.formData.donorResidentCountry"
                                    expanded>
                            <option v-for="country in countriesArray" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>




<!--              donors address start here-->
              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`">
                  {{ $root.selectedLanguageData.donorPermanentAddress }}
                </label>
                <!--permanent address house name-->
                <div class="mt-1">
                  <p>
                    {{ $root.selectedLanguageData.houseName }}
                    <span class="has-text-danger">*</span>
                  </p>
                  <b-field>
                    <ValidationProvider :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                      <p class="control has-icons-right">
                        <b-input type="text" @focus="$inputFocused('donor_permanent_address_line1')"
                                 @input="$inputChanged('donor_permanent_address_line1')"
                                 @blur="$inputBlured('donor_permanent_address_line1')"
                                 v-model="$root.formData.donor_permanent_address_line1"></b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="columns is-7 is-variable mt-2">
                  <!--permanent address street name-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.streetName }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('donor_permanent_address_line2')"
                                   @input="$inputChanged('donor_permanent_address_line2')"
                                   @blur="$inputBlured('donor_permanent_address_line2')"
                                   v-model="$root.formData.donor_permanent_address_line2"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--permanent address city-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.city }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('donor_permanent_address_line3')"
                                   @input="$inputChanged('donor_permanent_address_line3')"
                                   @blur="$inputBlured('donor_permanent_address_line3')"
                                   v-model="$root.formData.donor_permanent_address_line3"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>

                <div class="columns is-7 is-variable">
                  <!--permanent address postal code-->
                  <div class="column">
                    <p>{{ $root.selectedLanguageData.postalCode }}</p>
                    <b-field>
                      <ValidationProvider :rules="{ regex: /^\d{5}$/, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('permanent_address_postal_code')"
                                   @input="$inputChanged('permanent_address_postal_code')"
                                   @blur="$inputBlured('permanent_address_postal_code')"
                                   v-model="$root.formData.donor_permanent_address_postal_code">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--permanent address country-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.country }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('permanent_address_country')"
                                    @input="$inputChanged('permanent_address_country')"
                                    @blur="$inputBlured('permanent_address_country')"
                                    v-model="$root.formData.donor_permanent_address_country" expanded>
                            <option v-for="country in $root.selectedLanguageData
                                .countries" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>


              <div class="mt-4">
                <label :class="`${$root.selectedLanguage === `ta`? `ta-label`: $root.selectedLanguage === `si`? `si-label`: ``}`" >
                  {{ $root.selectedLanguageData.donorMailingAddress }}</label>
                <b-field>
                  <b-checkbox type="is-primary" @focus="$inputFocused('mailing_address_same_as_permanent_address')"
                              @input="$inputChanged('mailing_address_same_as_permanent_address')"
                              @blur="$inputBlured('mailing_address_same_as_permanent_address')"
                              v-model="$root.formData.donor_mailing_address_same_as_permanent_address"
                              :disabled="!$root.formData.donor_permanent_address_line1 ||
                                !$root.formData.donor_permanent_address_line2 ||
                                !$root.formData.donor_permanent_address_line3 ||
                                !$root.formData.donor_permanent_address_country"
                              @change.native="mailingAddress()">
                   <p style="font-size: 0.9rem">{{$root.selectedLanguageData.sameAsPermanentAddress }}</p>
                  </b-checkbox>
                </b-field>

                <!--mailing address house name-->
                <div class="mt-1">
                  <p>
                    {{ $root.selectedLanguageData.houseName }}
                    <span class="has-text-danger">*</span>
                  </p>
                  <b-field>
                    <ValidationProvider :rules="{ required: true, regex: /^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                      <p class="control has-icons-right">
                        <b-input type="text" @focus="$inputFocused('donor_mailing_address_line1')"
                                 @input="$inputChanged('donor_mailing_address_line1')"
                                 @blur="$inputBlured('donor_mailing_address_line1')"
                                 v-model="$root.formData.donor_mailing_address_line1"
                                 :disabled="$root.formData.donor_mailing_address_same_as_permanent_address">
                        </b-input>
                        <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/home.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                      </p>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="columns is-7 is-variable mt-2">
                  <!--mailing address street name-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.streetName }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider :rules="{ required: true, regex:/^[a-zA-Z0-9\s/,-]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('donor_mailing_address_line2')"
                                   @input="$inputChanged('donor_mailing_address_line2')"
                                   @blur="$inputBlured('donor_mailing_address_line2')"
                                   v-model="$root.formData.donor_mailing_address_line2"
                                   :disabled="$root.formData.donor_mailing_address_same_as_permanent_address">
                          </b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--mailing address city-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.city }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <b-field>
                      <ValidationProvider :rules="{ required: true, regex: /^[a-zA-Z\s]+$/i, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('donor_mailing_address_line3')"
                                   @input="$inputChanged('donor_mailing_address_line3')"
                                   @blur="$inputBlured('donor_mailing_address_line3')" v-model="$root.formData.donor_mailing_address_line3"
                                   :disabled="$root.formData.donor_mailing_address_same_as_permanent_address"></b-input>
                          <span class="icon is-small is-right">
                              <img src="../assets/images/icons/Blue/Location.png" alt="contact-name-img" width="25"
                                   height="25" />
                            </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>
                <div class="columns is-7 is-variable">
                  <!--mailing postal code-->
                  <div class="column">
                    <p>{{ $root.selectedLanguageData.postalCode }}</p>
                    <b-field>
                      <ValidationProvider :rules="{ regex: /^\d{5}$/, notEndsWith: ' ' }" v-slot="{ errors }">
                        <p class="control has-icons-right">
                          <b-input type="text" @focus="$inputFocused('donor_mailing_address_postal_code')"
                                   @input="$inputChanged('donor_mailing_address_postal_code')"
                                   @blur="$inputBlured('donor_mailing_address_postal_code')"
                                   v-model="$root.formData.donor_mailing_address_postal_code"
                                   :disabled="$root.formData.donor_mailing_address_same_as_permanent_address">
                          </b-input>
                          <span class="icon is-small is-right">
                            <img src="../assets/images/icons/Blue/Edit.png" alt="contact-name-img" width="25"
                                 height="25" />
                          </span>
                        </p>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-field>
                  </div>
                  <!--mailing address country-->
                  <div class="column">
                    <p>
                      {{ $root.selectedLanguageData.country }}
                      <span class="has-text-danger">*</span>
                    </p>
                    <div>
                      <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                        <div style="width: 100%">
                          <b-select @focus="$inputFocused('donor_mailing_address_country')"
                                    @input="$inputChanged('donor_mailing_address_country')"
                                    @blur="$inputBlured('donor_mailing_address_country')"
                                    v-model="$root.formData.donor_mailing_address_country"
                                    :disabled="$root.formData.donor_mailing_address_same_as_permanent_address" expanded>
                            <option v-for="country in $root.selectedLanguageData
                                .countries" :key="country.value" :value="country.value">
                              {{ country.countryName }}
                            </option>
                          </b-select>
                        </div>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>

<!--              donors address end here -->
             </div>



<!--              time plan select section start here -->
        <div class="columns">
              <div class="mb-5 mt-4 column is-half"  v-if="$root.formData.account_type === `Fixed Account`"> <!-- (v-if="$root.kycFieldVisibility.citizenship") need to add -->
                <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.timePeriod
                  }}<span class="has-text-danger">*</span></label>
                <div style="width: 100%">
                  <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">

                    <!-- <div v-if="$root.formData.account_name === `RDB Max`">
                    <b-select style="width: 100%" expanded v-model="$root.formData.account_time_period"
                              @focus="$inputFocused('account_time_period')" @input="
                        () => {
                          $inputChanged('account_time_period');

                        }
                      " @blur="$inputBlured('account_time_period')">

                      <option
                          v-for="timePlan in maxTimePlans"
                          :value="timePlan.timeDuration"
                          :key="timePlan.id">
                        {{ timePlan.timeDuration}}
                      </option>


                    </b-select>
                    </div> -->

                    <div v-if="$root.formData.account_type === `Fixed Account`">
                      <b-select style="width: 100%" expanded v-model="$root.formData.account_time_period" :disabled="$root.formData.account_name ===''"
                                @focus="$inputFocused('account_time_period')" @input="
                        () => {
                          $inputChanged('account_time_period');

                        }
                      " @blur="$inputBlured('account_time_period')">

                        <option
                         
                            v-for="timePlan in $root.formData.fixedAccountTimeDurations"
                            :value="timePlan"
                            :key="timePlan">
                          {{ timePlan}}
                        </option>

                      </b-select>
                    </div>

                    <!-- <div v-else-if="$root.formData.account_name === `RDB Jaya Nidhana`">
                      <b-select style="width: 100%" expanded v-model="$root.formData.account_time_period"
                                @focus="$inputFocused('account_time_period')" @input="
                        () => {
                          $inputChanged('account_time_period');
                        }
                      " @blur="$inputBlured('account_time_period')">

                        <option
                            v-for="timePlan in jayaNidhanaTimePlans"
                            :value="timePlan.timeDuration"
                            :key="timePlan.id">
                          {{ timePlan.timeDuration}}
                        </option>

                      </b-select>
                    </div> -->


                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              </div>
<!--              time plan select section end here-->


<div v-if="$root.formData.account_type === `Fixed Account`">
  <hr>
    <div class="columns">
      <div class="column">
        <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.interestPaymentAt
                  }}<span class="has-text-danger">*</span></label>
                   <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
          <b-select v-model="$root.formData.interestPayment" expanded>
             <option
                        v-for="payment in $root.selectedLanguageData
                          .interestPaymentsList"
                        :key="payment.value"
                        :value="payment.value"
                      >
                        {{ payment.langTranslation }}
                      </option>
          </b-select>
          <span class="has-text-danger">{{ errors[0] }}</span>
                   </ValidationProvider>

      </div>
        <div class="column">
          <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.transferMethod
                  }}<span class="has-text-danger">*</span></label>
                   <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
          <b-select v-model="$root.formData.interestPayable" expanded>
           <option
                        v-for="payable in $root.selectedLanguageData
                          .interestPayableList"
                        :key="payable.value"
                        :value="payable.value"
                      >
                        {{ payable.langTranslation }}
                      </option>
          </b-select>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                   </ValidationProvider>
      </div>
    </div>

           <div class="field mt-4">
                  <label :class="`${$root.selectedLanguage === `ta` ? `ta-label`: $root.selectedLanguage === `si` ? `si-label`: ``}`">
                    {{ $root.selectedLanguageData.selectTansferAccount}}
                    <span class="has-text-danger">*</span>
                  </label>

                  <div class="columns">
                    <div class="column is-4">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio
                              
                              name="Transfer Account" style="font-family: OpenSans-Regular" native-value="RDB"
                                   @focus="$inputFocused('nomineeGender')" 
                                   @blur="$inputBlured('nomineeGender')" v-model="$root.formData.transferAccount"
                                   @input="branchAndBranchListClearHandler()">
                            {{$root.selectedLanguageData.rdbBankAccount }}
                          </b-radio>
                          <span class="has-text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                    <div class="column is-4">
                      <b-field>
                        <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                          <b-radio name="Transfer Account" style="font-family: OpenSans-Regular" native-value="Other"
                                   @focus="$inputFocused('nomineeGender')" 
                                   @blur="$inputBlured('nomineeGender')" v-model="$root.formData.transferAccount" >
                            {{ $root.selectedLanguageData.otherBankAccount }}
                          </b-radio>
                          <span class="has-text-danger">{{errors[0] }}</span>
                        </ValidationProvider>
                      </b-field>
                    </div>
                  </div>
                </div>

                  <div class="columns" v-if="$root.formData.transferAccount === 'Other'">
      <div class="column">
        <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.bank
                  }}<span class="has-text-danger">*</span></label>
                  <ValidationProvider name="Other bank" :rules="{ required: true}" v-slot="{ errors }">
          <!-- <b-select v-model="$root.formData.otherBank" expanded @input="otherBanksBranchFilterHandler()">

                <option
                            v-for="bank in $root.dataLists.otherBankAndBranchList"
                            :value="bank.bank_name"
                            :key="bank">
                          {{ bank.bank_name}}
                        </option>
          </b-select> -->
            <b-autocomplete
                
                v-model="$root.formData.otherBank"
                :data="filteredOtherBankArry"
                icon-right="magnify"
                clearable
                @select="option => (selectedBank = option)"
                :keep-first="true"
                field="bank_name"
                :open-on-focus="true"
                @input="otherBanksBranchFilterHandler()"
                 @focus="$root.formData.otherBankBranch = ''"

                >
                <!-- <template #empty>No results found</template> -->
                                <template #empty>No results found</template>

            </b-autocomplete>
           
             <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>

      </div>
        <div class="column">
          <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.branch
                  }}<span class="has-text-danger">*</span></label>
                   <ValidationProvider name="Other bank branch" :rules="{ required: true}" v-slot="{ errors }">
          <!-- <b-select v-model="$root.formData.otherBankBranch" expanded :disabled="$root.formData.otherBank === ''">

               <option
                            v-for="bankBranch in $root.dataLists.selectBankBranches"
                            :value="bankBranch"
                            :key="bankBranch">
                          {{ bankBranch.branch_name}}
                        </option>

          </b-select> -->
              <b-autocomplete
                
                v-model="$root.formData.otherBankBranch"
                :data="filteredOtherBranchArry"
                icon-right="magnify"
                clearable
                field="branch_name"
                :keep-first="true"
                
                :open-on-focus="true"
                 :disabled="$root.formData.otherBank === ''"

                >
                <!-- <template #empty>No results found</template> -->
                                <template #empty>No results found</template>

            </b-autocomplete>
            <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
      </div>
    </div>


     <div class="columns" v-if="$root.formData.transferAccount === 'Other'">
      <div class="column">
        <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.accountNumber
                  }}
                  <span class="has-text-danger">*</span>
                </label>
                   <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider name="Account number" :rules="{ required: true, numeric: true}" v-slot="{ errors }">
          <b-input v-model="$root.formData.otherBankAccountNumber"/>
           <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />

                            </span>
                             <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
          </p>
          </b-field>

      </div>
        <div class="column">
          <label :class="`${$root.selectedLanguage === `ta`
                  ? `ta-label`
                  : $root.selectedLanguage === `si`
                    ? `si-label`
                    : ``
                  }`">
                  {{ $root.selectedLanguageData.accountHolderName
                  }}<span class="has-text-danger">*</span></label>
                   <b-field>
                  <p class="control has-icons-right">
                    <ValidationProvider name="Account Holder name" :rules="{ required: true, notEndsWith: ' ', alphaSpaces: true, notStartsWith: ' ' }" v-slot="{ errors }">
          <b-input v-model="$root.formData.otherBankAccountHolderName"/>
                     <span class="icon is-small is-right">
                              <img
                                  src="../assets/images/icons/Blue/Edit.png"
                                  alt="contact-name-img"
                                  width="25"
                                  height="25"
                              />

                            </span>
                             <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
          </p>
          </b-field>
      </div>
    </div>
    </div>



                



      <div v-if="$root.formData.account !==`Minor Savings` && $root.formData.haveNic == 'Yes'">
      <hr>
      <div class="columns">

        <div class="column is-11 has-text-weight-bold"> 
          {{$root.selectedLanguageData.do_you_need_to_appoint_nominees}}
        </div>

        <div class="column">
          <b-switch       :true-value="true"
                          :false-value="false"
                          v-model="$root.formData.isAgreeToNominees"
                          size="is-small"
                          @input="()=>{addNominee()}"
                          ></b-switch>

        </div>

      </div>

      <div v-if="$root.formData.isAgreeToNominees === true">

      <div class="columns">
        <div class="column colulmnLeft" style="text-align: justify;">
          <p style="margin-bottom: 10px">
          {{$root.selectedLanguageData.nominees_agreement_part_one}}
          </p>

          <p>{{$root.selectedLanguageData.nominees_agreement_part_two}}</p>

          </div>
      </div>

      <NomineesInfo
          @nameSetter="(name)=>{setNomineeName(name, 0)}"
          @nicSetter="(nic)=>{setNomineeNIC(nic, 0)}"
          @relationshipSetter="(relationship)=>{setNomineeRelationship(relationship, 0)}"
          @shareSetter="(share)=>{setNomineeShare(share, 0)}"
          @genderSetter="(gender)=>{setNomineeGender(gender, 0)}"
          @houseNameSetter="(house)=>{setNomineeHouseName(house, 0)}"
          @streetNameSetter="(street)=>{setNomineeStreetName(street, 0)}"
          @citySetter="(city)=>{setNomineeCity(city, 0)}"
          @postalCodeSetter="(postalCode)=>{setNomineePostalCode(postalCode, 0)}"
          @countrySetter="(country)=>{setNomineeCountry(country,0)}"
          @dobSetter="(dob)=>{setNomineeDob(dob, 0)}"
          @nicValidator="(invalidGender, sameNic)=>{setNicValidityOne(invalidGender, sameNic)}"
          :nomineeIndex="0"
          :isDisabled="false"
      />
      
      <!-- <b-button type="is-primary" inverted icon-left="plus-circle" class="nominees-add-btn">Add Nominee</b-button> -->
      <div class="nominees-add-btn my-3" @click="nomineeAddHandler">   
        <b-icon
                :icon="$root.formData.addAnotherNominee === false ? `plus-circle` : `minus-circle`"
                size="is-small"
                type="is-primary">
            </b-icon>
            <span v-if="$root.formData.addAnotherNominee === false" class="pl-1">Add Nominee</span>
            <span v-else-if="$root.formData.addAnotherNominee === true" class="pl-1">Remove Nominee</span>
      </div>

      <div v-if="$root.formData.addAnotherNominee === true">
        <NomineesInfo
            @nameSetter="(name)=>{setNomineeName(name, 1)}"
            @nicSetter="(nic)=>{setNomineeNIC(nic, 1)}"
            @relationshipSetter="(relationship)=>{setNomineeRelationship(relationship, 1)}"
            @shareSetter="(share)=>{setNomineeShare(share, 1)}"
            @genderSetter="(gender)=>{setNomineeGender(gender, 1)}"
            @houseNameSetter="(house)=>{setNomineeHouseName(house, 1)}"
            @streetNameSetter="(street)=>{setNomineeStreetName(street, 1)}"
            @citySetter="(city)=>{setNomineeCity(city, 1)}"
            @postalCodeSetter="(postalCode)=>{setNomineePostalCode(postalCode, 1)}"
            @countrySetter="(country)=>{setNomineeCountry(country,1)}"
            @dobSetter="(dob)=>{setNomineeDob(dob, 1)}"
            @nicValidator="(invalidGender, sameNic)=>{setNicValidityTwo(invalidGender, sameNic)}"
            :nomineeIndex="1"
            :isDisabled="false"
        />
      </div>

      <div v-if="$root.formData.addAnotherNominee === true" class="nominees-add-btn my-3" @click="thirdNomineeHandler">   
        <b-icon
                :icon="$root.formData.addThirdNominee === false ? `plus-circle` : `minus-circle`"
                size="is-small"
                type="is-primary">
        </b-icon>
        <span v-if="$root.formData.addThirdNominee === false" class="pl-1">Add Nominee</span>
        <span v-else-if="$root.formData.addThirdNominee === true" class="pl-1">Remove Nominee</span>
      </div>

      <div v-if="$root.formData.addThirdNominee === true">
        <NomineesInfo
            @nameSetter="(name)=>{setNomineeName(name, 2)}"
            @nicSetter="(nic)=>{setNomineeNIC(nic, 2)}"
            @relationshipSetter="(relationship)=>{setNomineeRelationship(relationship, 2)}"
            @shareSetter="(share)=>{setNomineeShare(share, 2)}"
            @genderSetter="(gender)=>{setNomineeGender(gender, 2)}"
            @houseNameSetter="(house)=>{setNomineeHouseName(house, 2)}"
            @streetNameSetter="(street)=>{setNomineeStreetName(street, 2)}"
            @citySetter="(city)=>{setNomineeCity(city, 2)}"
            @postalCodeSetter="(postalCode)=>{setNomineePostalCode(postalCode, 2)}"
            @countrySetter="(country)=>{setNomineeCountry(country,2)}"
            @dobSetter="(dob)=>{setNomineeDob(dob, 2)}"
            @nicValidator="(invalidGender, sameNic)=>{setNicValidityThree(invalidGender, sameNic)}"
            :nomineeIndex="2"
            :isDisabled="false"
        />
      </div>

      </div>
      
      <hr>
      </div>

              <div class="mb-5 mt-4  ">
              Visit <a href="https://www.rdb.lk/savings-investments/" target="_blank">https://www.rdb.lk/savings-investments/</a> for more information.
              </div>

              <div class="mb-5 mt-4 card px-5 innerCard">
                <div class="columns is-mobile is-1 is-variable">
                  <div class="column is-narrow">
                <b-switch :true-value=true
                          :false-value=false
                          v-model="$root.formData.isUserAgree"
                          size="is-small"
                          @input="clickUserAgree()"></b-switch>
                  </div>

                <div class="column">
                  <b-field >

                    <div v-show="!flagShowOne">
                      <p>
                        {{ $root.selectedLanguageData.iHereby }}
                        <span @click="flagShowOne = true" class="showcontant">{{
                            $root.selectedLanguageData.readMore
                          }}</span>
                      </p>
                    </div>

                    <div v-show="flagShowOne">
                      <p class="has-text-justified fontSizeDescrption">
                        {{ $root.selectedLanguageData.iHereby }}
                        <br>
                        <br>
                        {{$root.selectedLanguageData.revision_of_terms_and_conditions_seven_1}}
                        <br>
                        <br>
                        {{$root.selectedLanguageData.revision_of_terms_and_conditions_seven_2}}

                        <span @click="flagShowOne = false" class="showcontant">{{
                            $root.selectedLanguageData.shoeLess
                          }}</span>
                      </p>
                    </div>
                  </b-field>
                </div>
                </div>


                  <div class="columns is-mobile is-1 is-variable">
                    <div class="column is-narrow">
                <b-switch size="is-small"
                          :true-value=true
                          :false-value=false
                          @input="checkLocationService(); clickUserLocationAgree()"
                          v-model="$root.formData.locationService">
                </b-switch>
                    </div>
                    <div class="column">
                <b-field>

                      <div v-show="!flagShowTwo">
                        <p>
                          {{ $root.selectedLanguageData.allowLocation }}
                          <span @click="flagShowTwo = true;" class="showcontant">{{
                              $root.selectedLanguageData.readMore
                            }}</span>
                        </p>
                      </div>

                      <div v-show="flagShowTwo">
                        <p class="has-text-justified fontSizeDescrption">
                          {{ $root.selectedLanguageData.allowLocation }}
                          <br>
                          <br>
                          {{$root.selectedLanguageData.allow_location_condition_under_the_revised_guidelines}}

                          <span @click="flagShowTwo = false" class="showcontant">{{
                              $root.selectedLanguageData.shoeLess
                            }}</span>
                        </p>
                      </div>
                    </b-field>
                  </div>
                </div>
                  </div>

<!--          <div class="column ">-->
              <div class="columns is-flex is-justify-content-flex-end">
                <div class="column is-6 is-offset-4 is-flex is-flex-direction-row-reverse">


                  <b-button
                      :disabled="
                        invalid ||
                        !$root.formData.locationService== true ||
                        !$root.formData.isUserAgree == true||
                        !isNicExist ||
                        $root.formData.account_name === '' ||
                        !$root.formData.isShareOnLimit ||
                        $root.formData.sameNic ||
                        !isValidCountryCode ||
                        !isNicValid ||
                        $root.formData.invalidBeneNICOne ||
                        $root.formData.invalidBeneNICTwo ||
                        $root.formData.invalidBeneNICThree
                      "
                      @click="validateForm();"
                          :class="`is-primary  ${
                          $root.selectedLanguage === `ta`
                          ? `continue-button-ta`
                          : $root.selectedLanguage === `si`
                          ? `continue-button-si`
                          : `continue-button-en`
                      }`"
                      :loading="continueButtonIsLoading"
                  >
                    <!--@click="$router.push('otp')"-->
                    <!-- :disabled="invalid || userCode !== $root.formData.countryCode" -->

                    {{ $root.selectedLanguageData.continue }}
                  </b-button>
                  <b-button

                      @click="$router.push($root.isFromStatusCheck ? 'enter-name' : 'notice_info')"
                      :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"

                  >{{ $root.selectedLanguageData.back }}
                  </b-button>
                </div>
              </div>
<!--          </div>-->
<!--              -->
            </div>
          </div>
        </form>
      </ValidationObserver>

    </div>

    <b-modal v-model="isModalActive" :can-cancel="false" :scroll="false">
      <transition appear
                  @before-enter="$animations.beforeEnterBelow"
                  @enter="$animations.enterBelow"
      >
        <div class="opacity-select-card card" style="width: 80%; margin: auto; ">
          <header class="card-header">
            <p class="card-header-title is-centered is-size-4" style="font-family: OpenSans-Bold">
              {{ $root.selectedLanguageData.notice }}
            </p>
          </header>
          <div class="card-content" style="display: flex; justify-content: center">
            <p v-if="$root.formData.childrenAccountOpeningPurpose === `For another person's child (Gift Account)`">{{ $root.selectedLanguageData.forAnotherPersonChildModalContent }}</p>
            <p v-else-if="$root.formData.childrenAccountOpeningPurpose === `For my own child`">{{ $root.selectedLanguageData.forOwnChildModalContent }}</p>
          </div>
          <div class="card-content" style="display: flex; justify-content: center">
            <b-button
                style="margin: 0 auto"
                class="is-primary agree-button"
                :loading="continueButtonIsLoading"
                @click="()=>{
                  isModalActive = false
                }"
            >
              {{ $root.selectedLanguageData.ok }}
            </b-button>
          </div>
        </div>
      </transition>
    </b-modal>



  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Logo from "./NsbKycLogo.vue";
import NomineesInfo from  "./supports/page-section/NomineesInfo.vue"

// import { image } from 'vee-validate/dist/rules';
export default {

  data() {
    return {
      sampleNic : '',
      flagShowOne: false,
      flagShowTwo: false,
      isModalActive: false,
      countriesArray : [],
      branchArray : [],
      countryCodeList : [],
      countryCodePhoneList : [],
      countryIconString: "" ,
      countryCode: "+94",
      mobileNumber: "",
      selected: null,
      isMobileNumberStartsWithZero: false,
      isLandNumber: false,
      // locationService:"",
      regex: { mobileNumberRule : /^7[0-8][0-9]{7}$/ },
      // startTime: new Date(),
      continueButtonIsLoading : false,
      customerNic: "",
      isNicExist : true,
      isNicValid : true,
      userMail : '',
      userCountryCode : '',
      userMobileNumber : '',
      isValidCountryCode : true,
      otherBank : " ",
      otherBankList : [],
      isValidBankName : true,
      isValidOtherBankName : true,
      isValidOtherBranchName : true,
      
      




      // accountTypes: [
      //   {
      //     id: 1,
      //     name: "Saving",
      //   },
      //   {
      //     id: 2,
      //     name: "Fix Deposit"
      //   }
      // ],

      accounts: [
        {
          id: 1,
          name: 'RDB Max',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Max.png`),
          account_type: '',
          account: "Fixed Accounts",
          gender: "All",
          isNicRequired: true
        },
        // {
        //   id: 2,
        //   name: '4 teen plus',
        //   imgurl: require(`@/assets/images/icons/AccountLogos/image.png`),
        //   account_type: 'savings',
        //   account: "Normal Savingss"
        // },
        {
          id: 3,
          name: 'RDB Kekulu',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Kekulu.png`),
          account_type: 'savings',
          account: "Minor Savings",
          gender: "All",
          isNicRequired: true
        },
        {
          id: 4,
          name: 'RDB 4 teen plus ',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB 4 teen Plus.png`),
          account_type: 'savings',
          account: "Normal Savingss",
          gender: "All",
          isNicRequired: false
        },
        {
          id: 5,
          name: "RDB Liya Saviya",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Liya Saviya.png`),
          account_type: "savings",
          account: 'Normal Savingss',
          gender: "Female",
          isNicRequired: true
        },
        {
          id: 6,
          name: "RDB Liya Saviya Plus",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Liya Saviya Plus.png`),
          account_type: 'savings',
          account: "Investment Savingss",
          gender: "Female",
          isNicRequired: true
        },
        {
          id: 7,
          name: "RDB Uththama",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Uththama.png`),
          account_type: 'savings',
          account: "Normal Savingss",
          gender: "All",
          isNicRequired: true
        },
        {
          id: 8,
          name: "RDB Ayojana",
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Ayojana.png`),
          account_type: 'savings',
          account: "Investment Savingss",
          gender: "All",
          isNicRequired: true
        },
        {
          id: 9,
          name: 'RDB Fixed Deposit',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Fixed Deposits.png`),
          account_type: '',
          account: "Fixed Accounts",
          gender: "All",
          isNicRequired: true
        },
        {
          id: 10,
          name: 'RDB Victory',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Victory.png`),
          account_type: 'savings',
          account: "Normal Savingss",
          gender: "All",
          isNicRequired: true
        },
        {
          id: 11,
          name: 'RDB NewLife',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB New Life.png`),
          account_type: 'savings',
          account: "Normal Savingss",
          gender: "All",
          isNicRequired: true
        },
        {
          id: 12,
          name: 'RDB Dorin Dora',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Dorin Dora.png`),
          account_type: 'savings',
          account: "Normal Savingss",
          gender: "All",
          isNicRequired: true
        },
        {
          id: 13,
          name: 'RDB Jaya Nidhana',
          imgurl: require(`@/assets/images/icons/AccountLogos/RDB Jaya Nidana.png`),
          account_type: '',
          account: "Fixed Accounts",
          gender: "All",
          isNicRequired: true,
        },
      ],
      fixedTimePlans : [
        {
          id : 1,
          timeDuration : '1 month'
        },
        {
          id : 2,
          timeDuration : '2 month'
        },
        {
          id : 3,
          timeDuration : '3 month'
        },
        {
          id : 4,
          timeDuration : '4 month'
        },
        {
          id : 5,
          timeDuration : '6 month'
        },
        {
          id : 6,
          timeDuration : '1 year'
        },
        {
          id : 7,
          timeDuration : '2 year'
        },

        {
          id : 8,
          timeDuration : '3 year'
        },
        {
          id : 9,
          timeDuration : '4 year'
        },
        {
          id : 10,
          timeDuration : '5 year'
        },
      ],
      maxTimePlans : [

        {
          id : 1,
          timeDuration : '10 months'
        },

        {
          id : 2,
          timeDuration : '400 days'
        },
        {
          id : 3,
          timeDuration : '100 days'
        },
        {
          id : 4,
          timeDuration : '6 month'
        },
        {
          id : 5,
          timeDuration : '1 year'
        },

      ],
      jayaNidhanaTimePlans :[
        {
          id: 1,
          timeDuration : '1 year'
        }
      ],
      selectedBank : ""
    }
  },

  components: {
    Logo,
    ValidationObserver,
    ValidationProvider,
    NomineesInfo
  },

  methods: {

    checkBranchInput(selected){
      console.log("selected", selected.branch_name)
      console.log("this.$root.formData.branch", this.$root.formData.branch)
      console.log(selected.branch_name === this.$root.formData.branch)
        if(selected.branch_name === this.$root.formData.branch){
          this.isValidBankName = true
        }
        else{
          this.isValidBankName = false
        }
    },

    clearGernder(){
      if(this.$root.isPreviouslyDonorFilled === 1 || this.$root.formData.childrenAccountOpeningPurpose === `For my own child`){
        this.$root.formData.guardian_gender  = this.$root.formData.gender
        this.$root.formData.gender = '';
        }
      else if(this.$root.formData.childrenAccountOpeningPurpose === `For another person's child (Gift Account)`){
        this.$root.formData.gender = ''
      }
    },

    productImageSetter(imgSource){
      console.log("this.$baseUrl + '/' + imgSource",  `${this.$storageURL}/${imgSource}`)
      return this.$storageURL + '/' + imgSource
    },

     accountSelector(selectAccountName, selectAccountImage){
      //console.log(selectAccountName)
      this.$root.formData.account_name = selectAccountName;
      this.$root.formData.accountImage = this.$storageURL+ '/'+ selectAccountImage
      //console.log(this.$root.formData.account_name);
    },

    setNomineeName(name, index){
      this.$root.formData.nomineesData[index].name = name
    },

    setNomineeNIC(nic, index){
      this.$root.formData.nomineesData[index].nic = nic
    },

    setNomineeRelationship(relationship, index){
      this.$root.formData.nomineesData[index].relationship = relationship
    },

    setNomineeShare(share, index){
      this.$root.formData.nomineesData[index].share = share
    },

    setNomineeGender(gender, index){
      // const comp = this
      console.log( this.$root.formData.nomineesData,gender)
      this.$root.formData.nomineesData[index].gender = gender
     
    },

    setNomineeHouseName(houseName, index){
      this.$root.formData.nomineesData[index].houseName = houseName
    },

    setNomineeStreetName(streetName, index){
      this.$root.formData.nomineesData[index].streetName = streetName
    },

    setNomineeCity(city, index){
      this.$root.formData.nomineesData[index].city = city
    },

    setNomineePostalCode(postalCode, index){
      this.$root.formData.nomineesData[index].postalCode = postalCode
    },

    setNomineeCountry(country, index){
      this.$root.formData.nomineesData[index].country = country
    },

    setNomineeDob(dob, index){
      this.$root.formData.nomineesData[index].dob = dob
    },

    setNicValidityOne(invalidGender, sameNic) {
        this.$root.formData.invalidBeneNICOne = invalidGender || sameNic
    },

    setNicValidityTwo(invalidGender, sameNic) {
        this.$root.formData.invalidBeneNICTwo = invalidGender || sameNic
    },

    setNicValidityThree(invalidGender, sameNic) {
        this.$root.formData.invalidBeneNICThree = invalidGender || sameNic
    },

    otherBanksBranchFilterHandler(){
      // console.log("this.$root.formData.otherBank", this.$root.formData.otherBank)
      const selectedBank = this.$root.dataLists.otherBankAndBranchList.find((branch)=>
        branch.bank_name === this.$root.formData.otherBank
        
      )
      this.$root.dataLists.selectBankBranches = selectedBank.branches
      // this.$root.formData.selectBankBranches = 
      // console.log("Selected Bank", selectedBank)

    },

    fixedAccountTimeDurationSelector(){
        let selectedFixedAccount; 
        console.log()
        // this.$root.formData.fixedAccountTimeDurations
        selectedFixedAccount = this.$root.formData.productListArray.find((account) =>{
            return account.name === this.$root.formData.account_name
        })
        this.$root.formData.fixedAccountTimeDurations = selectedFixedAccount.time_duration

        console.log("Fixed time planes", selectedFixedAccount.time_duration)
        
    },

    branchAndBranchListClearHandler(){
      if(this.$root.formData.transferAccount !== 'Other'){
        this.$root.formData.otherBank = "";
        this.$root.formData.otherBankBranch = "";
        this.$root.formData.otherBankAccountNumber = "";
        this.$root.formData.otherBankAccountHolderName = "";

      }
    },

    getProductListLate(){
      setTimeout(() => {
        this.getProductList()
      }, 200);
    },

     getProductList(){
     
      console.log("this.$root.formData.haveNic ", this.$root.formData.haveNic)
      try{
         let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        this.$http
            .post(this.$baseURL + "/kycForm/getProductList", {'age': this.$root.formData.customerAge, 'gender': this.$root.formData.customer_gender, 'have_nic': this.$root.formData.haveNic},{
              headers: { "Content-Type": "multipart/form-data","X-token":kyc_token }
            })
            .then((response) => {
              console.log("Product List ", response.data.data.products);
              this.$root.formData.productListArray = response.data.data.products
              // this.$root.formData.otherBankAndBranchList = Object.values(response.data.banksWithBranches);
              // console.log("this.$root.formData.otherBankAndBranchList", this.$root.formData.otherBankAndBranchList);
              
            })
      }catch(err){
        console.log(err)
      }
    },


    addNominee(){

      console.log("this.$root.formData.isAgreeToNominees ", this.$root.formData.isAgreeToNominees)
      if(this.$root.formData.isAgreeToNominees === true){

        console.log("Hello")

        }
        else{
          this.$root.formData.nomineesData[0].name = ""
          this.$root.formData.nomineesData[1].name = ""
          this.$root.formData.nomineesData[0].share = ""
          this.$root.formData.nomineesData[1].share = ""
          this.$root.formData.nomineesData[0].nic = ""
          this.$root.formData.nomineesData[1].nic = ""
          this.$root.formData.nomineesData[0].relationship = ""
          this.$root.formData.nomineesData[1].relationship = ""
          this.$root.formData.nomineesData[0].gender = ""
          this.$root.formData.nomineesData[1].gender = ""
          this.$root.formData.nomineesData[0].houseName = ""
          this.$root.formData.nomineesData[1].houseName =  ""
          this.$root.formData.nomineesData[0].streetName = ""
          this.$root.formData.nomineesData[1].streetName = ""
          this.$root.formData.nomineesData[0].city = ""
          this.$root.formData.nomineesData[1].city = ""
          this.$root.formData.nomineesData[0].postalCode = ""
          this.$root.formData.nomineesData[1].postalCode = ""
          this.$root.formData.nomineesData[0].country = ""
          this.$root.formData.nomineesData[0].dob = ""
          this.$root.formData.nomineesData[1].dob = ""

          this.$root.formData.nomineesData[2].name = ""
          this.$root.formData.nomineesData[2].share = ""
          this.$root.formData.nomineesData[2].nic = ""
          this.$root.formData.nomineesData[2].relationship = ""
          this.$root.formData.nomineesData[2].gender = ""
          this.$root.formData.nomineesData[2].houseName =  ""
          this.$root.formData.nomineesData[2].streetName = ""
          this.$root.formData.nomineesData[2].city = ""
          this.$root.formData.nomineesData[2].postalCode = ""
          this.$root.formData.nomineesData[2].dob = ""

        }
    },

    nomineeAddHandler(){
      console.log("Nominee Handler kicked")
      if(this.$root.formData.addAnotherNominee === false){
        this.$root.formData.addAnotherNominee  = true
      }
      else if(this.$root.formData.addAnotherNominee === true){
        this.$root.formData.addAnotherNominee = false
        this.$root.formData.addThirdNominee = false

        this.$root.formData.nomineesData[1].name = ""
        this.$root.formData.nomineesData[1].share = ""
        this.$root.formData.nomineesData[1].nic = ""
        this.$root.formData.nomineesData[1].relationship = ""
        this.$root.formData.nomineesData[1].gender = ""
        this.$root.formData.nomineesData[1].houseName =  ""
        this.$root.formData.nomineesData[1].streetName = ""
        this.$root.formData.nomineesData[1].city = ""
        this.$root.formData.nomineesData[1].postalCode = ""
        this.$root.formData.nomineesData[1].dob = ""

        
      }
    },

    thirdNomineeHandler(){
        if(this.$root.formData.addThirdNominee === false){
          this.$root.formData.addThirdNominee = true
        }
        else if(this.$root.formData.addThirdNominee === true){
        this.$root.formData.addThirdNominee = false

        this.$root.formData.nomineesData[2].name = ""
        this.$root.formData.nomineesData[2].share = ""
        this.$root.formData.nomineesData[2].nic = ""
        this.$root.formData.nomineesData[2].relationship = ""
        this.$root.formData.nomineesData[2].gender = ""
        this.$root.formData.nomineesData[2].houseName =  ""
        this.$root.formData.nomineesData[2].streetName = ""
        this.$root.formData.nomineesData[2].city = ""
        this.$root.formData.nomineesData[2].postalCode = ""
        this.$root.formData.nomineesData[2].dob = ""
      }
    },

    previousDataCleaner(){
      if (this.$root.isPreviouslyDonorFilled === 1){
        this.$root.formData.childrenAccountOpeningPurpose ="For my own child"
      }
    },


    // previousNavigationChecker(){
    //   this.$router.beforeEach(async (to, from) => {
    //     this.previousRoute = from
    //     console.log("Previous Page" + from)
    //
    //
    //   })
    // },

    mailingAddress() {
      if (this.$root.formData.donor_mailing_address_same_as_permanent_address) {
        this.$root.formData.donor_mailing_address_line1 =
            this.$root.formData.donor_permanent_address_line1;
        this.$root.formData.donor_mailing_address_line2 =
            this.$root.formData.donor_permanent_address_line2;
        this.$root.formData.donor_mailing_address_line3 =
            this.$root.formData.donor_permanent_address_line3;
        this.$root.formData.donor_mailing_address_postal_code =
            this.$root.formData.donor_permanent_address_postal_code;
        this.$root.formData.donor_mailing_address_country =
            this.$root.formData.donor_permanent_address_country;
      } else {
        this.$root.formData.donor_mailing_address_line1 = "";
        this.$root.formData.donor_mailing_address_line2 = "";
        this.$root.formData.donor_mailing_address_line3 = "";
        this.$root.formData.donor_mailing_address_postal_code = "";
        this.$root.formData.donor_mailing_address_country = "";
      }
    },

    // bankNameValidator(){
    //   this.isValidBankName =  this.$root.dataLists.branchListArray.includes()
    // },



    clickUserAgree(){
      if(this.$root.formData.isUserAgree === true){
        this.flagShowOne = true;
      }
      else {
        this.flagShowOne = false;
      }

    },
    clickUserLocationAgree(){
      if (this.$root.formData.locationService === true){
        this.flagShowTwo = true;
      }
      else {
        this.flagShowTwo = false;
      }
    },

    validateForm(){

      if(this.$root.formData.location_details.form_submitted == null){
        this.$buefy.toast.open({
          message: "Please allow location service in your browser",
          type: "is-danger",
        });
        this.$root.formData.locationService= false;
        if(this.$root.formData.locationService== true ){


          this.getLocationFromBrowser();
        }
      }else{
        this.getNICAlreadyExsist()

        // this.$router.push('otp')
      }
    },

    splitNic() {
      // this.kycFormStore.isNicChange = true;
      // this.$root.formData.customer_nic = this.customerNic
      if (this.$root.formData.customer_nic.length === 10) {
        this.$root.formData.idType = "ONIC";
      } else {
        this.$root.formData.idType = "NNIC";
      }
    },
  donorValueResetter(){
    if (this.$root.formData.childrenAccountOpeningPurpose !== `For another person's child (Gift Account)`) {
      this.$root.formData.donorsName = ''
      this.$root.formData.donor_permanent_address_line1 = ''
      this.$root.formData.donor_permanent_address_line2 = ''
      this.$root.formData.donor_permanent_address_line3 = ''
      this.$root.formData.donor_permanent_address_postal_code = ''
      this.$root.formData.donor_permanent_address_country = ''
      this.$root.formData.donor_mailing_address_line1 = ''
      this.$root.formData.donor_mailing_address_line2 = ''
      this.$root.formData.donor_mailing_address_line3 = ''
      this.$root.formData.donor_mailing_address_postal_code = ''
      this.$root.formData.donor_mailing_address_country = ''

    }
  },




    fixedAccountSelector(){
      if (this.$root.formData.account_type === "Fixed Account"){
        this.$root.formData.account = "";
      }
      else{
        this.$root.formData.account_time_period = '';
        this.$root.formData.interestPayment = '';
        this.$root.formData.interestPayable = '';
        this.$root.formData.transferAccount = '';
        this.$root.formData.otherBank = '';
        this.$root.formData.otherBankBranch = '';
        this.$root.formData.otherBankAccountNumber = '';
        this.$root.formData.otherBankAccountHolderName = '';
        this.$root.formData.account_name = '';
      }
    },

    childrenAccountOpenPurposeHandler(){
      if(this.$root.formData.account !==`Minor Savings`){
        this.$root.formData.childrenAccountOpeningPurpose = ''
      }
    },

    checkLocationService(){
      if(this.$root.formData.locationService == true){
        this.getLocationFromBrowser()
      }else if(this.$root.formData.locationService == false){
        this.$root.formData.location_details.form_submitted = null;
      }
    },

    getLocationFromBrowser() {
      try {
        var comp = this;
        navigator.geolocation.getCurrentPosition(function (pos) {
          comp.$root.formData.location_details.form_submitted = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
            accuracy: pos.coords.accuracy,
          };

         // console.log(pos.coords);
         // console.log(comp.$root.formData.location_details);

          if (comp.$root.formData.location_details.form_submitted != null) {
            if (
                comp.$root.formData.nicNumberAllowToLocationServicesInYourBrowser
                    .length > 0
            ) {
              comp.$root.formData.locationAccess =
                  comp.$root.formData.nicNumberAllowToLocationServicesInYourBrowser;
            } else {
              comp.$root.formData.locationAccess = "";
            }

            if (comp.$root.formData.nicNumberAllowToDRP.length > 0) {
              comp.$root.formData.nicVerificationDRP =
                  comp.$root.formData.nicNumberAllowToDRP[0];
            } else {
              comp.$root.formData.nicVerificationDRP = "";
            }

            comp.navigateToNextPage();
          } else {
            comp.$buefy.toast.open({
              message: "Failed to capture location from browser",
              type: "is-danger",
            });
          }
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to capture location from browser",
          type: "is-danger",
        });
      }
    },

    countryCodeValidation() {
      let obj = {
          regex : /^\+\d{1,4}$/,
        required: true,

      };
      return obj;
    },



    // getBranchesList(){
    //   try{
    //     let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
    //     this.$http
    //         .post(this.$baseURL + "/kycForm/getBranches", {},{
    //           headers:{'X-token':kyc_token}
    //         })
    //         .then((response) => {
    //           console.log(response.data.data.branches);
    //           this.branchArray = response.data.data.branches;
    //
    //         })
    //
    //   }catch(err){
    //     console.log(err)
    //   }
    // },

    // getCountyCodeList(){
    //   try{
    //     let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
    //     this.$http
    //         .post(this.$baseURL + "/getAllCountries", {},{
    //           headers:{'X-token':kyc_token}
    //         })
    //         .then((response) => {
    //           console.log(response.data.countries);
    //
    //           this.countryCodeList = response.data.data.countries;
    //           this.countryCodeList.forEach(country =>{
    //             this.countryCodePhoneList.push(country.phone)
    //           })
    //
    //           console.log("new array")
    //           console.log(this.countryCodePhoneList)
    //
    //         })
    //
    //   }catch(err){
    //     console.log(err)
    //   }
    // },
    nicDuplicator(){
      const comp = this
      comp.sampleNic = comp.$root.formData.customer_nic
      return comp.sampleNic
    },
    getNICAlreadyExsist(){
      try{
        this.continueButtonIsLoading = true

        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        this.$http
            .post(this.$baseURL + "/kycForm/checkNICExist", {"nic_number" : this.$root.formData.customer_nic, "account" : this.$root.formData.account, "account_type": this.$root.formData.account_type, "select_account":  this.$root.formData.account_name },{
              headers:{'X-token':kyc_token}
            })
            .then((response) => {
             // console.log(response.data);
              this.continueButtonIsLoading = false
              this.isNicExist = response.data.success
              console.log("is nic exsist ", this.isNicExist)
              if(!this.isNicExist){

                this.$buefy.toast.open({
                  message: response.data.message,
                  type: "is-danger",
                });

              }else{

                if(this.$root.isPreviouslyDonorFilled === 1){
                  this.$root.formData.guardian_email = this.userMail
                  this.$root.formData.guardian_countryCode = this.userCountryCode
                  this.$root.formData.guardian_mobileNumber = this.userMobileNumber
                  this.$root.formData.mobileNumber = this.$root.formData.guardian_countryCode + this.$root.formData.guardian_mobileNumber
                }
                else if(this.$root.isPreviouslyDonorFilled === 0){
                  this.$root.formData.email = this.userMail
                  this.$root.formData.countryCode = this.userCountryCode
                  this.$root.formData.mobileNumberWithoutCountryCode = this.userMobileNumber
                  this.$root.formData.mobileNumber = this.$root.formData.countryCode+this.$root.formData.mobileNumberWithoutCountryCode;
                }
                this.$router.push('otp')
              }

            })
      }catch(err){
        console.log(err)
      }

    },

    dualCitizenCounties() {
      this.$root.formData.dual_citizen_countries = [];
    },
    countrySelect(value) {
      this.$root.formData.permanent_address_country = value;
      this.$root.formData.mailing_address_country = value;
    },

    calPhoneNumber() {
      console.log('this.isLandNumber ', this.isLandNumber)
      if (this.userCountryCode === "+94") {

       // console.log("LK Mobile number ---------------");
        const tempMobileNumber = this.userMobileNumber.trim();

        // let lanDigits = ["9","8","6","5","4","3","2","1","0"]
        if (tempMobileNumber[0] === "0") {
          this.isMobileNumberStartsWithZero = true;

        }
        // else if (lanDigits.includes(tempMobileNumber[0])){
        //   this.isLandNumber =true;
        // }
        else if (!this.regex.mobileNumberRule.test(this.userMobileNumber)){
          this.isLandNumber = true;

        }

        else {
          this.isMobileNumberStartsWithZero = false;
          this.isLandNumber =false;
        }
      } 
      else {
        this.isMobileNumberStartsWithZero = false;
        this.isLandNumber =false;

      }
      this.$root.formData.mobileNumber = `${this.$root.formData.countryCode}${this.$root.formData.mobileNumberWithoutCountryCode}`;
      // console.log(
      //   "Contact Number Formatted : " + this.$root.formData.mobileNumber
      // );
    },
    concatMobileNumber(){
      // this.$root.formData.countryCode = this.countryCode
      // this.$root.formData.mobileNumberWithoutCountryCode = this.mobileNumber
      this.$root.formData.mobileNumber = this.$root.formData.countryCode+this.$root.formData.mobileNumberWithoutCountryCode;

    },
    rootVaribaleChanger(){
      if(this.$root.isPreviouslyDonorFilled === 1){
            this.userMail = this.$root.formData.guardian_email
            this.userCountryCode =  this.$root.formData.guardian_countryCode
            this.userMobileNumber = this.$root.formData.guardian_mobileNumber
      }
      else if(this.$root.isPreviouslyDonorFilled === 0){
        this.userMail = this.$root.formData.email
        this.userCountryCode =  this.$root.formData.countryCode
        this.userMobileNumber = this.$root.formData.mobileNumberWithoutCountryCode
      }
    },

    changeSelection() {
      const countryCodeTemp = this.$root.formData.countriesList.find(
        (countryObject) =>
          // countryObject.phone === this.$root.formData.countryCode
          countryObject.code === this.$root.formData.mobileNumberCountrySelectionTemp.split(" ")[0]
      );
      this.$root.formData.country_short_name = `${countryCodeTemp.code} ${countryCodeTemp.phone}`;
      this.iconString = `fi fi-${countryCodeTemp.code.toLowerCase()}`;
    },

    accountFilter(acctype) {
      // let selectedAccounts = this.$root.formData.productListArray.filter(account => account.account === acctype);
      // if(this.$root.formData.gender === 'Female'){
      //   //console.log(selectedAccounts.filter(selectedAccount=>(selectedAccount.gender === "All" || selectedAccount.gender === "Female")))
      //   return selectedAccounts.filter(selectedAccount=> selectedAccount.gender === "All" || selectedAccount.gender === "Female"
      //   )
      // }
      // else if (this.$root.formData.gender === 'Male'){
      //   //console.log(selectedAccounts.filter(selectedAccount=>selectedAccount.gender !== "Female"))
      //   return selectedAccounts.filter(selectedAccount=>selectedAccount.gender !== "Female")
      // }
      // else if (this.$root.formData.haveNic === 'No'){
      //   console.log(selectedAccounts.filter(selectedAccount=>selectedAccount.isNicRequired === false))
      //   return selectedAccounts.filter(selectedAccount=>selectedAccount.isNicRequired === false)
      // }
      // let selectAccount;
      if(this.$root.formData.account_type === 'Savings Account'){
        return this.$root.formData.productListArray.filter(account => account.account === acctype);
      }
      else if(this.$root.formData.account_type === 'Fixed Account'){
        return this.$root.formData.productListArray.filter(account => account.account_type === acctype);

      }
    },

   

    countryCodeLogoFilter(){
      //console.log('countryCodeLogoFilter --------')
      let countryCodeIndex = this.$root.dataLists.countryCodeListArray.findIndex(country => country.phone == this.userCountryCode)
      //console.log('index ---'+this.$root.dataLists.countryCodeListArray[countryCodeIndex].code.toLowerCase())
      this.$root.formData.countryIconString = `fi fi-${this.$root.dataLists.countryCodeListArray[countryCodeIndex].code.toLowerCase()}`;
      //console.log(this.$root.formData.countryIconString);
    },

    countryCodeValidator(){

      this.isValidCountryCode = this.$root.dataLists.countryCodeNumbersListArray.includes(this.userCountryCode)
      console.log("this.userCountryCode", this.userCountryCode)
      console.log("this.isValidCountryCode", this.isValidCountryCode)

        
    },

    nicGenderCheck(){
      let genderValue
      let intGenderValue
      if(this.$root.formData.customer_nic.length === 10){
        genderValue = this.$root.formData.customer_nic.slice(2, 5);
        intGenderValue = parseInt(genderValue, 10)
        if(intGenderValue>=500){
          this.$root.formData.gender = "Female"
        
        }
        else{
          this.$root.formData.gender = "Male"
         
        }
      }
      else if (this.$root.formData.customer_nic.length === 12){
        genderValue = this.$root.formData.customer_nic.slice(4, 7);
        intGenderValue = parseInt(genderValue, 10)
        if(intGenderValue>=500){
          this.$root.formData.gender = "Female"
         
        }
        else{
          this.$root.formData.gender = "Male"
           
        }
      }

    },

  calculateDateOfBirth () {
  let curruntYear = new Date().getFullYear()
  let year;
  let genderValue;
  let monthAndDayInDays;
 
  // let dateOfBirth;

  if (this.$root.formData.customer_nic.length === 10) {
    genderValue = this.$root.formData.customer_nic.slice(2, 5);
    monthAndDayInDays =
      parseInt(genderValue, 10) >= 500
        ? parseInt(genderValue - 500, 10)
        : parseInt(genderValue, 10);
    year = parseInt(`19${this.$root.formData.customer_nic.slice(0, 2)}`, 10);
  } else if (this.$root.formData.customer_nic.length === 12) {
    genderValue = this.$root.formData.customer_nic.slice(4, 7);
    monthAndDayInDays =
      parseInt(genderValue, 10) >= 500
        ? parseInt(genderValue - 500, 10)
        : parseInt(genderValue, 10);
    year = parseInt(`${this.$root.formData.customer_nic.slice(0, 4)}`, 10);
  }
  let month;
  let day;
  if (monthAndDayInDays <= 31) {
    month = "01";
    if (monthAndDayInDays < 10) {
      day = `0${monthAndDayInDays}`;
    } else {
      day = monthAndDayInDays;
    }
  } else if (monthAndDayInDays <= 60) {
    month = "02";
    day = monthAndDayInDays - 31;
  } else if (monthAndDayInDays <= 91) {
    month = "03";
    day = monthAndDayInDays - 60;
  } else if (monthAndDayInDays <= 121) {
    month = "04";
    day = monthAndDayInDays - 91;
  } else if (monthAndDayInDays <= 152) {
    month = "05";
    day = monthAndDayInDays - 121;
  } else if (monthAndDayInDays <= 182) {
    month = "06";
    day = monthAndDayInDays - 152;
  } else if (monthAndDayInDays <= 213) {
    month = "07";
    day = monthAndDayInDays - 182;
  } else if (monthAndDayInDays <= 244) {
    month = "08";
    day = monthAndDayInDays - 213;
  } else if (monthAndDayInDays <= 274) {
    month = "09";
    day = monthAndDayInDays - 244;
  } else if (monthAndDayInDays <= 305) {
    month = "10";
    day = monthAndDayInDays - 274;
  } else if (monthAndDayInDays <= 335) {
    month = "11";
    day = monthAndDayInDays - 305;
  } else {
    month = "12";
    day = monthAndDayInDays - 335;
  }

  this.$root.formData.customer_dob = month + "/" + day + "/" + year

  

   this.$root.formData.customer_gender = genderValue < 500 ? "Male" : "Female";
   this.$root.formData.customerAge = curruntYear-year

   if(this.$root.formData.customerAge < 16){
    this.isNicValid = false
   }
   else if (this.$root.formData.customerAge >=16){
    this.isNicValid = true
    
   }
},


    

    

    

  },


  created() {
    //this.getBranchesList()
  },

  mounted() {
    // this.getColorCodeData();
    // this.previousNavigationChecker()
    // setTimeout(()=>{
    //   this.getBranchesList();
    // },5000)
    //this.getCountyCodeList();
    this.countriesArray = this.$root.selectedLanguageData.countries.filter(
        (item) => item.value !== "Sri Lanka"
    );

    this.rootVaribaleChanger()

    // this.otherBankList = this.$root.dataLists.otherBankAndBranchList;

    



    this.previousDataCleaner()
  },
  computed: {
    filteredDataArray() {
      const list = this.$root.dataLists.countryCodeNumbersListArray;
      const isExactMatch = list.some(
        (option) =>
          option.toString().toLowerCase() === this.userCountryCode.toLowerCase()
      );
      if (isExactMatch) {
        return list;
      }
      return list.filter((option) => {
        return option
            .toString()
            .toLowerCase()
            .indexOf(this.userCountryCode.toLowerCase()) >= 0
      })
    },

    filteredOtherBankArry(){
      const comp = this
      // console.log(comp.otherBankList[0].bank_name,"branch")
       return comp.$root.dataLists.otherBankAndBranchList.filter((option) => {
        console.log()
        return option.bank_name
            .toString()
            .toLowerCase()
            .indexOf(comp.$root.formData.otherBank.toLowerCase()) >= 0
      })

    },

      filteredOtherBranchArry(){
      const comp = this
      // console.log(comp.otherBankList[0].bank_name,"branch")
       return comp.$root.dataLists.selectBankBranches.filter((option) => {
        console.log()
        return option.branch_name
            .toString()
            .toLowerCase()
            .indexOf(comp.$root.formData.otherBankBranch.toLowerCase()) >= 0
      })

    },
       filteredBranchArry(){
      const comp = this
      // console.log(comp.otherBankList[0].bank_name,"branch")
       return comp.$root.dataLists.branchListArray.filter((option) => {
        console.log()
        return option.branch_name
            .toString()
            .toLowerCase()
            .indexOf(comp.$root.formData.branch.toLowerCase()) >= 0
      })

    }

  },
  watch:{
    
    sampleNic(newSampleNic, oldSampleNic){
      // if(newCustomerNic.length < oldCustomerNic.length){
      //   this.isNicExist = true
      if(newSampleNic != oldSampleNic){
        this.isNicExist = true
      }
    }

    },

    



  // }


}
</script>

<style scoped>

.nominees-add-btn{
  color: #009ec2;
  cursor: pointer
}
@media only screen and (max-width: 500px) {
  .fontSizeDescrption{
    font-size: 0.6rem;
    word-wrap: break-word;


  }
  .colulmnLeft{
    text-align: left;
  }
  .innerCard{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }
}





</style>